import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * Study Icon
 *
 * @file Study.jsx
 * @author Nivedhitha M
 */
const Study = (props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <SvgIcon viewBox="0 0 23 23" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.5412 2.73762L14.7618 1.92041C14.123 1.09088 13.1089 0.555268 11.9696 0.557441L4.01903
      0.5726C2.09797 0.576262 0.548577 2.10759 0.558358 3.99292L0.624132 16.6723C0.633912 18.5576
      2.19917 20.083 4.12022 20.0794L6.98975 20.0739C7.38762 20.3396 7.84802 20.5284 8.35251 20.6146L16.1893
      21.9546C18.0829 22.2784 19.8806 21.0352 20.2045 19.1779L22.3832 6.68684C22.7072 4.82953 21.4348 3.0614
      19.5412 2.73762ZM13.4781 3.96828L13.5438 16.6477C13.548 17.4557 12.884 18.112 12.0607 18.1135L4.1101
      18.1287C3.28679 18.1303 2.61597 17.4765 2.61178 16.6685L2.546 3.98913C2.54181 3.18113 3.20584 2.52485
      4.02915 2.52328L11.9797 2.50812C12.8031 2.50655 13.4739 3.16029 13.4781 3.96828ZM20.424 6.35185L18.2453
      18.8429C18.1065 19.6389 17.3361 20.1717 16.5245 20.0329L13.8552 19.5765C14.8654 18.9779 15.5379 17.888
      15.5315 16.6439L15.466 4.01983L19.206 4.65932C20.0175 4.79808 20.5629 5.55585 20.424 6.35185ZM10.2499
      10.6731C10.8022 10.6707 11.2518 11.1165 11.2542 11.6688C11.2565 12.2211 10.8107 12.6707 10.2585
      12.6731L5.7585 12.6922C5.20622 12.6945 4.7566 12.2487 4.75425 11.6965C4.7519 11.1442 5.19771 10.6946
      5.74999 10.6922L10.2499 10.6731ZM11.5042 8.24926C11.5018 7.69698 11.1082 7.25093 10.6249 7.25299L5.37499
      7.27532C4.89175 7.27738 4.5019 7.72676 4.50425 8.27904C4.5066 8.83132 4.90025 9.27736 5.3835 9.27531L10.6335
      9.25297C11.1167 9.25091 11.5065 8.80154 11.5042 8.24926Z"
      fill="currentcolor"
    />
  </SvgIcon>
);

export default Study;
